// extracted by mini-css-extract-plugin
module.exports = {"softContentItem":"softcontent-item_softContentItem__YF52L"};